import React from 'react'
import { Icon } from '@chakra-ui/react'
import { PDFDownloadLink } from '@react-pdf/renderer'
import { FaFilePdf } from 'react-icons/fa6'
import { format } from 'date-fns'

import {
    PatientFieldsFragment,
    PatientVaccinationRecordFieldsFragment,
} from '~graphql/generated/graphql'
import VaccinationRecordsPDFDocument from './pdf-document'
import SharedButton from '~components/shared/buttons/shared-button'
import { useClinic } from '~contexts/clinic-context'

interface Props {
    patient: PatientFieldsFragment
    vaccines: PatientVaccinationRecordFieldsFragment[]
}

export default function ExportVaccinationRecordsButton({
    patient,
    vaccines,
}: Props) {
    const { clinic } = useClinic()
    const document = (
        <VaccinationRecordsPDFDocument
            clinic={clinic}
            patient={patient}
            vaccines={vaccines}
        />
    )

    return (
        <PDFDownloadLink
            document={document}
            fileName={`${getSafeFileName(patient.name)} Vaccination Records (${format(Date.now(), 'yyyy-MM-dd')}).pdf`}
        >
            {/* @ts-ignore */}
            {({ loading }) => (
                <SharedButton
                    colorScheme="purple"
                    isLoading={loading}
                    leftIcon={<Icon as={FaFilePdf} />}
                    loadingText="Loading..."
                    size="xs"
                    variant="subtle"
                >
                    Generate PDF
                </SharedButton>
            )}
        </PDFDownloadLink>
    )
}

function getSafeFileName(name: string | null | undefined) {
    return (name || 'Patient').replace(/[<>:"/\\|?*]+/g, '').trim()
}
